import { type ReactElement } from 'react';
import styles from './how-to-gain-points-slice.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { LoyaltyAllActionEnum } from '@utmb/types/enum/LoyaltyAllActionEnum';
import { IconsEnum } from '@utmb/types/icons';
import { Icon } from '@utmb/design-system/icons/Icon';
import { getColorStyle, getLoyaltyColor } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { LoyaltyLevelEnum } from '@utmb/types/enum/LoyaltyLevelEnum';
import MyUtmbPoints from '@utmb/design-system/my-utmb-points/MyUtmbPoints';

export interface HowToGaminPointsSliceProps {
    action: LoyaltyAllActionEnum;
    title: string;
    description?: string;
    children?: ReactElement;
    quantity?: number;
    level?: LoyaltyLevelEnum;
}

export function HowToGaminPointsSlice({ children, title, action, quantity, level, description }: HowToGaminPointsSliceProps): ReactElement | null {
    function getActionIcon(action: LoyaltyAllActionEnum) {
        if (action === LoyaltyAllActionEnum.CONTEST_WINNER) {
            return IconsEnum.GAME;
        } else if (action === LoyaltyAllActionEnum.DONATE_LEVEL1) {
            return IconsEnum.DONATION;
        } else if (action === LoyaltyAllActionEnum.DONATE_LEVEL2) {
            return IconsEnum.DONATION;
        } else if (action === LoyaltyAllActionEnum.DONATE_LEVEL3) {
            return IconsEnum.DONATION;
        } else if (action === LoyaltyAllActionEnum.FINISH_RACE) {
            return IconsEnum.FINISH_INDEX;
        } else if (action === LoyaltyAllActionEnum.FINISH_RACE_WS) {
            return IconsEnum.FINISH_INDEX;
        } else if (action === LoyaltyAllActionEnum.INIT) {
            return IconsEnum.OTHER;
        } else if (action === LoyaltyAllActionEnum.MOBILITY_TICKET) {
            return IconsEnum.MOBILITY;
        } else if (action === LoyaltyAllActionEnum.OTHER) {
            return IconsEnum.OTHER;
        } else if (action === LoyaltyAllActionEnum.PARTICIPATE_RACE) {
            return IconsEnum.BIB;
        } else if (action === LoyaltyAllActionEnum.PARTICIPATE_RACE_WS) {
            return IconsEnum.BIB;
        } else if (action === LoyaltyAllActionEnum.SOLIDARITY_BIB) {
            return IconsEnum.CHARITY_BIB;
        } else if (action === LoyaltyAllActionEnum.VOLUNTEER) {
            return IconsEnum.VOLONTEER;
        } else {
            return IconsEnum.OTHER;
        }
    }
    return (
        <div className={styles.howToGaminPointsSlice}>
            <div className={styles.header}>
                <div className={styles.wrapIcons}>
                    {action ? <Icon variant={getActionIcon(action)} width={32} height={32} color={getColorStyle(ColorTypesEnum.PRIMARY)} /> : null}
                </div>

                <Font.FuturaBold className={styles.title} color={getColorStyle(ColorTypesEnum.PRIMARY)} desktop="18" mobile="18">
                    {title}
                </Font.FuturaBold>
            </div>
            {quantity ? (
                <div className={styles.wrapQuantity}>
                    <MyUtmbPoints color={getLoyaltyColor(level ?? LoyaltyLevelEnum.LEVEL0)} quantity={quantity} />
                </div>
            ) : null}
            {children ? <div className={styles.content}>{children}</div> : null}
            <Font.FuturaMedium desktop="14" mobile="14" color={getColorStyle(ColorTypesEnum.PRIMARY)}>
                {description}
            </Font.FuturaMedium>
        </div>
    );
}
